export default {
  id: 'EditLessonForm',
  code: 'CN',
  text: {
    'Add New Lesson': '排新课节',
    'Note': '备注',
    'The start and end date of the scheduling did not cover the class date selected, so a total of 0 lessons were created': '您设置的批量排课起止日期未覆盖您选择的上课日期，所以共排了0节课。',
    'End Time Must Be Later Than Start Time': '结束时间必须晚于开始时间',
    'All Fields with * Must Be Filled': '带*號的字段必須填寫',
    '': '',
  },
}



// WEBPACK FOOTER //
// ./src/template/Forms/EditLesson/locale.js